import s from './style.module.scss';
import { useState } from 'react';
import Switch from '../Switch';
import cx from 'classnames';

function StrictlyNecessaryModal({ setDetailModal, permissions, setPermissions, permissionsRef }) {
  const [showDetail, setShowDetail] = useState();

  const handleToggle = (key, checked) => {
    const currentMarketing = permissionsRef.current.marketing;
    const updatedMarketing = { ...currentMarketing, [key]: checked };
    setPermissions((prev) => ({ ...prev, marketing: updatedMarketing }));
  };

  const handleBack = () => {
    if (showDetail) {
      setShowDetail(false);
    } else {
      setDetailModal(null);
    }
  };

  return (
    <>
      {showDetail ? (
        <>
          {showDetail === 'appsflyer' && (
            <>
              <div className={s.settings__title}>Name</div>
              <div className={s.settings__text}>Appsflyer</div>
              <div className={s.settings__title}>Description</div>
              <div className={s.settings__text}>
                Enables Duet to measure the performance of its own marketing campaigns and improve them over time.
              </div>
              <div className={s.settings__title}>URL</div>
              <div className={s.settings__text}>
                <a href="https://www.appsflyer.com/privacy-policy/">https://www.appsflyer.com/privacy-policy/</a>
              </div>
            </>
          )}
          {showDetail === 'tiktok' && (
            <>
              <div className={s.settings__title}>Name</div>
              <div className={s.settings__text}>TikTok</div>
              <div className={s.settings__title}>Description</div>
              <div className={s.settings__text}>
                Enables Duet to measure the performance of TikTok marketing campaigns and improve them over time.
              </div>
              <div className={s.settings__title}>URL</div>
              <div className={s.settings__text}>
                <a href="https://www.tiktok.com/legal/privacy-policy/en">https://www.tiktok.com/legal/privacy-policy</a>
              </div>
            </>
          )}
          {showDetail === 'facebook' && (
            <>
              <div className={s.settings__title}>Name</div>
              <div className={s.settings__text}>Facebook</div>
              <div className={s.settings__title}>Description</div>
              <div className={s.settings__text}>
                Enables Duet to measure the performance of Facebook marketing campaigns and improve them over time.
              </div>
              <div className={s.settings__title}>URL</div>
              <div className={s.settings__text}>
                <a href="https://www.facebook.com/privacy/policy">https://www.facebook.com/privacy/policy</a>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div className={s.settings__text}>
            You can toggle any Marketing Permissions on and off. We may add new partners from time to time. They will be
            added to this list. You can change your settings below at any time.
          </div>

          <div className={s.settings__item_1}>
            <div>
              <div>Allow AppsFlyer</div>
              <div className={s.button} onClick={() => setShowDetail('appsflyer')}>
                View Details
              </div>
            </div>
            <Switch
              checked={permissions.marketing?.appsflyer === true}
              onChange={(checked) => handleToggle('appsflyer', checked)}
            />
          </div>

          <div className={s.settings__item_1}>
            <div>
              <div>Allow TikTok</div>
              <div className={s.button} onClick={() => setShowDetail('tiktok')}>
                View Details
              </div>
            </div>
            <Switch
              checked={permissions.marketing?.tiktok === true}
              onChange={(checked) => handleToggle('tiktok', checked)}
            />
          </div>

          <div className={s.settings__item_1}>
            <div>
              <div>Allow Facebook</div>
              <div className={s.button} onClick={() => setShowDetail('facebook')}>
                View Details
              </div>
            </div>
            <Switch
              checked={permissions.marketing?.facebook === true}
              onChange={(checked) => handleToggle('facebook', checked)}
            />
          </div>

          {/* new advertising perssion */}
          <div className={cx(s.settings__item_1, s.new)}>
            <div>
              <div>Allow new Marketing Permissions</div>
              <div className={s.button}>
                We may add new trackers. This setting determines whether these new trackers will be enabled or disabled
                by default.
              </div>
            </div>
            <Switch checked={permissions.marketing?.default === true} onChange={(checked) => handleToggle('default', checked)} />
          </div>
        </>
      )}
      <div className={s.backArrow} onClick={handleBack}>
        <div className={s.arrow} />
      </div>
    </>
  );
}

export default StrictlyNecessaryModal;
